import React from "react";
import styles from "../styles/Partner.module.css";

const Partner = () => {

    const pub = process.env.PUBLIC_URL;

    return (
        <div className={styles.page}>
            {/* <img src={`${process.env.PUBLIC_URL}/main/7p/7p.png`} alt='1page' /> */}
            <div id={styles[`partner`]}>
                <div className={styles.top}>
                    <div className={styles.imgArea}>
                        <img src={`${pub}/main/7p/001.png`} alt="background" className={styles.backImg}/>
                    </div>
                    <div className={styles.textArea}>
                        <div className={styles.textGroup}>
                            <p><span>주식회사 오퍼그룹</span>은</p>
                            <p>소상공인, 자영업자, 개인, 기업과 같이 더불어 동반 성장을 하기위해 끊임없이 도전하고 있습니다.</p>
                        </div>
                        <div className={styles.textGroup}>
                            <p>체계적인 서비스와 전문 인력으로</p>
                            <p>오로지 운영과 사업의 성장에만 집중할 수 있도록 지원하는 (주)오퍼그룹과 함께 해보세요.</p>
                        </div>
                    </div>
                </div>
                <div className={styles.bottom}>
                    <div className={styles.textArea}>
                        <span className={styles.backTitle}>BUSINESS PARTNER</span>
                        <div className={styles.tBox}>
                            <p>BUSINESS SOLUTION COMPANY</p>
                        </div>
                    </div>
                    <div className={styles.imgArea}>

                        <div className={styles.lineContainer}>
                            <div className={styles.station}>
                                <img src={`${pub}/main/7p/002.png`} alt="Station02" className={styles.stationImage} />
                                <div className={styles.circle}></div>
                                <div className={styles.label}>접수 및 상담</div>
                            </div>
                            <div className={styles.station}>
                                <img src={`${pub}/main/7p/003.png`} alt="Station03" className={styles.stationImage} />
                                <div className={styles.circle}></div>
                                <div className={styles.label}>담당자 배정 후 미팅</div>
                            </div>
                            <div className={styles.station}>
                                <img src={`${pub}/main/7p/004.png`} alt="Station04" className={styles.stationImage} />
                                <div className={styles.circle}></div>
                                <div className={styles.label}>서류 제출</div>
                            </div>
                            <div className={styles.station}>
                                <img src={`${pub}/main/7p/005.png`} alt="Station05" className={styles.stationImage} />
                                <div className={styles.circle}></div>
                                <div className={styles.label}>심사</div>
                            </div>
                            <div className={styles.station}>
                                <img src={`${pub}/main/7p/006.png`} alt="Station06" className={styles.stationImage} />
                                <div className={styles.circle}></div>
                                <div className={styles.label}>계약서 작성</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Partner;